import { getGravatarProfile } from "api/external/gravatar/gravatar-profile";

export const queryGravatarProfile = ({ hash }) => ({
	queryKey: ["gravatar-profile", hash],
	queryFn: async () => getGravatarProfile({ hash }),
});
